export class ProgramsByTypeApiModel {
  public Programs: ProgramByTypeApiModel[];

  public deserialize(data) {
    this.Programs = data.Programs.map((program) => new ProgramByTypeApiModel().deserialize(program));

    return this;
  }
}

export class ProgramByTypeApiModel {
  public Name: string;
  public Value: number;

  public deserialize(data) {
    this.Name = data.name;
    this.Value = data.value;

    return this;
  }
}
